import { fork, all } from 'redux-saga/effects'

import clients from './clients'

export default function* rootSaga() {
  yield all([
    fork(clients),
  ])
}